import React, { useEffect, useState } from 'react';
import IntlMessage from '../components/IntlMessage';
import {
  BillStatus,
  OrderStatus,
  PayStatus,
  BillTypes,
  VoucherStatus,
  LeadStatus,
  CampaignType,
} from '../utils/constant';

const useStatus = () => {
  const [orderStatusFilter, setOrderStatusFilter] = useState([]);
  const [payStatusFilter, setPayStatusFilter] = useState([]);
  const [billTypesFilter, setBillTypesFilter] = useState([]);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState([]);
  const [voucherStatusFilter, setVoucherStatusFilter] = useState([]);
  const [leadStatusFilter, setLeadStatusFilter] = useState([]);
  const [campaignTypeFilter, setCampaignTypeFilter] = useState([]);

  useEffect(() => {
    const filters = Object.keys(OrderStatus).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    // filters.unshift({ id: null, title: <IntlMessage id="global.all" /> });
    setOrderStatusFilter(filters);
  }, []);

  useEffect(() => {
    const filters = Object.keys(PayStatus).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    // filters.unshift({ id: null, title: <IntlMessage id="global.all" /> });
    setPayStatusFilter(filters);
  }, []);

  useEffect(() => {
    const filters = Object.keys(BillTypes).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    // filters.unshift({ id: null, title: <IntlMessage id="global.all" /> });
    setBillTypesFilter(filters);
  }, []);

  useEffect(() => {
    const filters = Object.keys(BillStatus).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    // filters.unshift({ id: null, title: <IntlMessage id="global.all" /> });
    setPaymentStatusFilter(filters);
  }, []);

  useEffect(() => {
    const filters = Object.keys(VoucherStatus).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    setVoucherStatusFilter(filters);
  }, []);

  useEffect(() => {
    const filters = Object.keys(LeadStatus).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    setLeadStatusFilter(filters);
  }, []);

  useEffect(() => {
    const filters = Object.keys(CampaignType).map((item, index) => {
      return {
        id: item,
        title: <IntlMessage id={`global.${item}`} />,
      };
    });
    setCampaignTypeFilter(filters);
  }, []);

  return {
    orderStatusFilter,
    payStatusFilter,
    billTypesFilter,
    paymentStatusFilter,
    voucherStatusFilter,
    leadStatusFilter,
    campaignTypeFilter,
  };
};

export default useStatus;
